import Axios from "../../api/Axios";

const fetch = ({ localID }) => {
  return (dispatch) => {
    Axios.get("/webApp/reports", { params: { localID } })
      .then((response) => {
        dispatch({ type: "FETCH_REPORTS", payload: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

const fetchSinaderReports = ({ localID }) => {
  return (dispatch) => {
    Axios.get("/webApp/sinaderReports", { params: { localID } })
      .then((response) => {
        dispatch({ type: "FETCH_REPORTS", payload: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

const createReport = (payload) => {
  return async (dispatch) => {
    try {
	    const response = await Axios.post("/webApp/download-report", { ...payload });
      return response.data;
    } catch (e) {
      return false;
    }
  };
};

export default {
  fetch,
  fetchSinaderReports,
  createReport
};
